import axios from "axios";

const attachInterceptors = (client) => {
  client.interceptors.request.use((config) => {
    const token = localStorage.getItem("auth");
    const salaRaw = localStorage.getItem("sala");
    let sala = null;

    try {
      sala = salaRaw ? JSON.parse(salaRaw) : null;
    } catch (e) {
      sala = null;
    }

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (sala && sala.id > 0) {
      config.headers = config.headers || {};
      config.headers["X-Sala-ID"] = sala.id;
    }

    return config;
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error && error.response && error.response.status === 401) {
        window.location = "/logout";
      }
      return Promise.reject(error);
    }
  );
};

const createHttpClient = (baseURL = null) => {
  const client = axios.create(baseURL ? { baseURL } : {});
  attachInterceptors(client);
  return client;
};

const httpClient = createHttpClient();

export { createHttpClient };
export default httpClient;
